<script setup lang="ts">
import IconLogo from 'assets/logo-full.svg';

const padding = useBigLayoutPadding();
</script>

<template>
  <header>
    <div
      :style="{
        'padding-left': `${padding}px`,
        'padding-right': `${padding}px`,
      }"
      :class="['pt-[52px] pb-8 max-lg:pt-6 max-lg:pb-1']"
      class="w-full border-b border-gray-300 flex justify-between gap-4"
    >
      <!--    <FreeDeliveryBanner /> -->

      <ButtonLevel href="/">
        <IconLogo
          class="h-[54px] min-w-[242px] cursor-pointer"
        />
      </ButtonLevel>
      <div class="flex gap-4 max-xl:hidden">
        <MainMenuList />
        <div class="h-[42px] flex items-center gap-4">
          <LanguageSelect />
          <CartButton />
          <AuthBlock />
        </div>
      </div>

      <!--    <div class="lg:hidden bg-red-500 w-4 h-4" /> -->
      <MobileHeaderMenuMain />
    </div>
  </header>
</template>

<style scoped></style>
